import React, {useCallback} from "react";
import {PERMISSIONS_ASSIGNMENT_FILTER_TREE_DATA} from "./permissionsManagementFilters.constants";
import {PermissionsAssignmentFilterKey} from "./permissionsManagementFilters.types";
import {PermissionsManagementFilterDropdown} from "./PermissionsManagementFilterDropdown";
import {PermissionsManagementFilterSelectorWrapper} from "./permissionsManagementFilters.styles";

type Props = Readonly<{
  selectedFilters: ReadonlyArray<PermissionsAssignmentFilterKey>;
  onFiltersChange: (filters: ReadonlyArray<PermissionsAssignmentFilterKey>) => void;
}>;

/**
 * Placeholder filter UI. POST /users/fetch does not accept a permissions-assignment
 * filter yet — selection is stored locally but does not affect the query.
 */
export const PermissionsManagementPermissionsFilter = ({
  selectedFilters,
  onFiltersChange,
}: Props) => {
  const handleCheck = useCallback(
    (_: string[], checkedLeafKeys: string[]) => {
      onFiltersChange(checkedLeafKeys as PermissionsAssignmentFilterKey[]);
    },
    [onFiltersChange],
  );

  return (
    <PermissionsManagementFilterSelectorWrapper>
      <PermissionsManagementFilterDropdown
        checkedKeys={[...selectedFilters]}
        triggerLabel="Permissions"
        onCheck={handleCheck}
        treeData={PERMISSIONS_ASSIGNMENT_FILTER_TREE_DATA}
        withApplyFiltersButton
      />
    </PermissionsManagementFilterSelectorWrapper>
  );
};
